import { createFileRoute } from "@tanstack/react-router";
import FamilyOfficesInversores from "@/pages/FamilyOfficesInversores";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/family-offices-investors")({
  head: () => pageHead("familyOffices", "en", { links: false }),
  component: FamilyOfficesInversores,
});
